<template>
  <b-modal :active.sync="opened" width="800px" scroll="keep">
    <div class="card">
      <div class="card-content tw-p-6">
        <div class="section-block tw-mb-5">
          <div class="title">Message Group Leaders</div>
        </div>
        <div class="columns">
          <div class="column">
            <p class="tw-text-justify tw-mr-5">
              This is where you can send short message to the leaders of this
              group. Only the group leaders will see this message in their
              notifications tab. They won't be able to reply to you, make sure
              you give them an alternate way to contact you!
              <em> (For example, your email or social media handle ) </em
              ><br /><br />
              <strong>
                Important: Don't share any personal or sensitive information
                here
              </strong>
            </p>
          </div>
          <div class="column">
            <validation-observer v-slot="{ valid }" ref="form">
              <validation-provider
                name="message"
                rules="required|max:1500|min:50"
                v-slot="{ errors }"
              >
                <b-field
                  label="Message"
                  :message="errors"
                  :type="{ 'is-danger': errors.length }"
                >
                  <b-input
                    type="textarea"
                    v-model="form.message"
                    maxlength="1500"
                    custom-class="message-textarea"
                  ></b-input>
                </b-field>
              </validation-provider>
              <div class="tw-text-right tw-mt-10">
                <b-button
                  type="is-primary"
                  :loading="isLoading"
                  :disabled="isLoading || !valid"
                  @click.prevent="sendMessage()"
                  >Send</b-button
                >
              </div>
            </validation-observer>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      opened: false,
      isLoading: false,
      form: {
        message: ''
      }
    }
  },
  computed: {
    ...mapState({
      group: state => state.group.currentGroup
    })
  },
  methods: {
    open() {
      this.opened = true
    },
    sendMessage() {
      this.form.$busy = this.isLoading = true

      this.$api
        .post('/groups/' + this.group.id + '/message-leaders', this.form)
        .then(async ({ data }) => {
          if (data.data.id) {
            this.$buefy.snackbar.open({
              message: 'Message has been sent',
              type: 'is-success',
              position: 'is-top'
            })

            this.opened = false
            this.form.message = ''
            await this.$refs.form.reset()
          }
        })
        .catch(({ response }) => {
          if (response.data && response.data.errors) {
            this.$refs.form.setErrors(response.data.errors)
          }
        })
        .finally(() => {
          this.form.$busy = this.isLoading = false
        })
    }
  }
}
</script>

<style lang="scss">
.message-textarea {
  height: 250px;
  font-size: 1.1em;
}
</style>
